<template>
	<div
		class="w-full p-4 lg:p-8 bg-white rounded-2xl border border-slate-100 lg:border-none relative overflow-hidden lg:overflow-visible lg:max-h-none"
	>
		<!-- Title Skeleton -->
		<div class="mb-4 lg:mb-8">
			<div
				class="h-7 lg:h-9 bg-slate-300/[0.1] rounded animate-pulse w-[200px]"
			></div>
		</div>

		<!-- News Grid Skeleton -->
		<div class="grid grid-cols-1 md:grid-cols-2">
			<div
				v-for="i in 4"
				:key="i"
				:class="[
					'flex items-start gap-4',
					i % 2 === 1 ? 'lg:pr-4 lg:border-r border-slate-200' : 'lg:pl-4'
				]"
			>
				<div
					class="flex items-start gap-4 border-slate-200 py-4 w-full justify-between"
					:class="{
						'border-t': i !== 1 && i !== 2,
						'border-b md:border-b-0': i !== 4,
						'lg:pt-0': i === 1 || i === 2,
						'pt-0': i === 1,
						'lg:pb-0': i === 3 || i === 4
					}"
				>
					<!-- Content Section -->
					<div class="flex flex-col justify-center h-full flex-1">
						<!-- Title Skeleton -->
						<div class="mb-2">
							<div
								class="h-5 lg:h-6 bg-slate-300/[0.1] rounded animate-pulse mb-1"
							></div>
							<div
								class="h-5 lg:h-6 bg-slate-300/[0.1] rounded animate-pulse w-3/4"
							></div>
						</div>

						<!-- Author & Date Skeleton -->
						<div class="mt-2">
							<div class="h-4 bg-slate-300/[0.1] rounded animate-pulse w-32"></div>
						</div>
					</div>

					<!-- Image Skeleton -->
					<div
						class="w-[120px] h-[120px] bg-slate-300/[0.1] rounded animate-pulse flex-shrink-0 ml-auto"
					></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
// No props needed - pure skeleton component
</script>

<style scoped>
/* Enhanced pulsating animation */
@keyframes pulse {
	0%,
	100% {
		opacity: 1;
	}
	50% {
		opacity: 0.7;
	}
}

.animate-pulse {
	animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

/* Staggered animation for more natural loading effect */
.animate-pulse:nth-child(1) {
	animation-delay: 0s;
}
.animate-pulse:nth-child(2) {
	animation-delay: 0.15s;
}
.animate-pulse:nth-child(3) {
	animation-delay: 0.3s;
}

/* Different delay for each news item */
div:nth-child(1) .animate-pulse {
	animation-delay: 0s;
}
div:nth-child(2) .animate-pulse {
	animation-delay: 0.1s;
}
div:nth-child(3) .animate-pulse {
	animation-delay: 0.2s;
}
div:nth-child(4) .animate-pulse {
	animation-delay: 0.3s;
}
</style>
